import * as React from "react";
import { IHistory } from "../domains/pslHistory.domain";
import { DateTime } from "luxon";
import { MaterialReactTable, useMaterialReactTable, MRT_PaginationState } from "material-react-table";
import { useMemo, useState } from "react";

const pslStatuses = [
    "Pending",
    "Approved",
    "Rejected",
    "Pending to Accept Changes",
    "Quality Pending",
    "Quality Rejected",
];

interface PromoTableProps {
    showBorder: boolean;
    loading: boolean;
    data: IHistory[];
    totalCount: number;
}
export const isDate = (_date) => {
    const _regExp = new RegExp('^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])T(2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(.[0-9]+)?(Z)?$');
    return _regExp.test(_date);
}
export const capitalizeFirstLetter = (string?) => string ? string.charAt(0).toUpperCase() + string.slice(1) : ""


const getFormattedText = (value: any): string => {
  if (value === null || value === undefined) {
    return "";
  }

  // Arrays
  if (Array.isArray(value)) {
    if (value.length === 0) {
      return "";
    }
    return value.join(", ");
  }

  // Objects
  if (typeof value === "object") {
    return JSON.stringify(value);
  }

  // Convert numbers/booleans to string
  const stringValue = String(value).trim();

  if (!stringValue) {
    return "";
  }

  return stringValue.charAt(0).toUpperCase() + stringValue.slice(1);
};

export function PromoHistoryTable(props: PromoTableProps) {
    const [pagination, setPagination] = useState<MRT_PaginationState>({
        pageIndex: 0,
        pageSize: 50,
    });

    const columns = useMemo<any[]>(
        () => [
            {
                accessorKey: "modifiedOn",
                header: "Updated On",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span>{row?.original?.modifiedOn ? DateTime.fromJSDate(new Date(row?.original?.modifiedOn)).toFormat("dd/MM/yyyy HH:mm:ss") : ""}</span>
                },
            },
            {
                accessorKey: "field",
                header: "Field",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span>{row.original?.field}</span>
                },
            },
            {
                accessorKey: "action",
                header: "Action",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span>{row.original?.action}</span>
                },
            },
            {
                accessorKey: "oldValue",
                header: "old Value",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span style={{ wordBreak: "break-word" }}>{row.original?.field === "pslStatus" ? pslStatuses[+row.original?.oldValue] : getFormattedText(row?.original?.oldValue)}</span>
                },
            },
            {
                accessorKey: "value",
                header: "new Value",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span style={{ wordBreak: "break-word" }}>{row.original?.field === "pslStatus" ? pslStatuses[+row.original?.value] : getFormattedText(row?.original?.value)}</span>
                },
            },
            {
                accessorKey: "user",
                header: "user",
                size: 150,
                enableSorting: false,
                Cell: ({ row }) => {
                    return <span>{row.original?.user}</span>
                },
            },
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data: props.data,
        enableRowActions: false,
        enableColumnOrdering: true,
        enableFilters: false,
        enableStickyHeader: true,
        manualFiltering: true,
        manualPagination: false, // Changed to false for client-side pagination
        manualSorting: true,
        onPaginationChange: setPagination,
        state: {
            pagination,
            isLoading: props.loading,
        },
        mrtTheme: {
            baseBackgroundColor: "#fff",
        },
        initialState: {
            pagination: {
                pageIndex: 0,
                pageSize: 50,
            },
            columnPinning: {
                left: ["mrt-row-expand", "mrt-row-select"],
                right: ["mrt-row-actions"],
            },
        },
        muiTablePaperProps: ({ table }) => ({
            //not sx
            style: {
                zIndex: table.getState().isFullScreen ? 1300 : undefined,
            },
        }),
    });

    return <MaterialReactTable
        table={table}
    />
}
